import { render, staticRenderFns } from "./sofyre-user-manual.vue?vue&type=template&id=596451fe&scoped=true&"
import script from "./sofyre-user-manual.vue?vue&type=script&lang=js&"
export * from "./sofyre-user-manual.vue?vue&type=script&lang=js&"
import style0 from "./sofyre-user-manual.vue?vue&type=style&index=0&id=596451fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596451fe",
  null
  
)

export default component.exports